export function openPaymentPopup(): Window | null {
  const popup = globalThis.open('about:blank', '_blank');
  if (!popup) {
    return null;
  }

  const referrerPolicy = popup.document.createElement('meta');
  referrerPolicy.name = 'referrer';
  referrerPolicy.content = 'no-referrer';
  popup.document.head.append(referrerPolicy);
  popup.opener = null;

  return popup;
}

export function navigatePaymentPopup(popup: Window, approvalUrl: string): void {
  popup.location.replace(approvalUrl);
}
